import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import filters from './helpers/filters'

import '../src/assets/styles.scss';
import bootstrap from './assets/js/bootstrap.bundle.min.js';
import 'vue3-emoji-picker/css';

window.bootstrap = bootstrap;

import jQuery from "jquery"
window.$ = window.jQuery = require('jquery');
import moment from 'moment';

import ToastPlugin, { useToast } from 'vue-toast-notification';
import 'vue-toast-notification/dist/theme-bootstrap.css';

import VueBlocksTree from 'vue3-blocks-tree';
import 'vue3-blocks-tree/dist/vue3-blocks-tree.css';
import Vuex from 'vuex'; 
import EmojiPicker from 'vue3-emoji-picker'
import 'vue3-emoji-picker/css'

// window.$store = store;
window.isChatComponentActive = false

const app = createApp(App)
    .use(Vuex)
    .use(router)
    .use(store)
    .use(jQuery)
    .use(moment)
    .use(ToastPlugin,{ position: 'top-right', duration: 4000, dismissible:true})
    .use(VueBlocksTree,{treeName:'blocks-tree'})

app.config.globalProperties.$filters = filters;
app.component('EmojiPicker', EmojiPicker)

app.mount('#app');
const toast = useToast();
      
import axios from "axios"
axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['Authorization'] ='Bearer ' + localStorage.getItem('_token');
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';

// This code will catch 401 status returend requests 
let isHandling401Error = false;
axios.interceptors.response.use(function (response){
    return response;
},function (error){
    if(error.response && error.response.status == 401) {
        if (!isHandling401Error) {
            isHandling401Error = true; 

            if(window.location.pathname.startsWith('/user-chat-panel')) {
                if (window.location.pathname.split('/')[2]) {
                    if (window.parent !== window) {
                        window.parent.postMessage(error.response.data, '*');
                    } else {
                        toast.error('Your chat session has expired. Please open a new chat link.');
                    }
                } else {
                    const providerName = localStorage.getItem('end_user_provider') || 'default';
                    localStorage.removeItem('end_user_token');
                    window.location.href = `/user-login/${encodeURIComponent(providerName)}`;
                }
            } else if(window.location.pathname.startsWith('/user-login') || error.config?.url?.includes('user-login')) {
                // Stay on user-login page on 401 (e.g. invalid credentials)
            } else if(window.location.pathname === '/login' || error.config?.url?.includes('/login')) {
                // Stay on admin login page on 401 (e.g. invalid credentials)
            } else if(window.location.href.indexOf("/support-chat/") > -1 || window.location.href.indexOf("/support-chat-new/") > -1) {
                window.parent.postMessage(error.response.data, '*');
            } else {
                toast.error('UnAuthenticated', {position: "top-right"});
                localStorage.removeItem('authData'); 
                localStorage.removeItem('_token'); 
                window.location.href = '/login'
                // router.push('/login') 
            }
            setTimeout(() => {
                isHandling401Error = false;
            }, 1000);
        }
    }
    store.commit('is_loader', false);
    return Promise.reject(error); // Ensure rejection of the promise
})

import Echo from 'laravel-echo';
window.io = require('socket.io-client');
// Have this in case you stop running your laravel echo server
if (typeof io !== 'undefined') {
    window.Echo = new Echo({
        broadcaster: 'socket.io',
        namespace: 'App\\Events',
        host: process.env.VUE_APP_WEBSOCKETS_SERVER+':2096',
        authEndpoint: "/api/broadcasting/auth",
        // authEndpoint: process.env.VUE_APP_API_BASE_URL+ ":" + process.env.VUE_APP_API_PORT + "/api/broadcasting/auth",
        // wsHost: process.env.VUE_APP_WEBSOCKETS_SERVER,
        // wsPort: 2096,
        auth: {
            headers: {
                Authorization: 'Bearer ' + localStorage.getItem('_token'),
            },
        },
        transports: ['websocket'],
    });
    
    window.Echo.connector.socket.on("connect", function () {
        console.log("---------CONNECTED---------");
    });
    
    window.Echo.connector.socket.on("reconnecting", function () {
        console.log("---------CONNECTING---------");
    });
    
    window.Echo.connector.socket.on("disconnect", function () {
        console.log("---------DISCONNECTED---------");
    });
}
